import React from 'react'


const ManagementModeToggle = ({ publicationManagementMode, togglePublicationManagementMode, clearAllPublicationApprovalFilters }) => {

    const handleToggle = () => {
        clearAllPublicationApprovalFilters()
        togglePublicationManagementMode()
    }

    return(
        <div className="publication-management-container">
            <label style={{cursor: "pointer"}}>
                <input
                    type="checkbox"
                    checked={publicationManagementMode}
                    onChange={handleToggle}
                    style={{marginRight: "10px", cursor: "pointer"}}
                />
                Activate Publication Management Mode
            </label>
            {publicationManagementMode ?
                <div className="publication-management-key">
                    <p><span style={{color:"#B0D8A4"}}>&#9632;</span> Green = Approved</p>
                    <p><span style={{color:"#FEE191"}}>&#9632;</span> Yellow = Complete without approval</p>
                    <p><span style={{color:"#FD8060"}}>&#9632;</span> Red = Incomplete</p>
                </div>
                :
                null
            }
        </div>
    )
}

export default ManagementModeToggle


// WEBPACK FOOTER //
// ./src/routes/publications/components/ManagementModeToggle.js